import LoadingSpinner from "./LoadingSpinner";
import { ComponentPropsWithoutRef, forwardRef } from "react";

export const LoadingScreen = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<"div">>(
  (props, ref) => {
    return (
      <div {...props} ref={ref} className="relative flex h-full w-full items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  },
);
